import React from 'react';
import './About.css';

const About = ({ onNavigate }) => {
  const handleClick = (e, pageId) => {
    if (window.innerWidth > 900) {
      e.preventDefault();
      onNavigate(pageId);
    }
  };

  return (
    <div className="about">
      <div className="about-left">
        <div className="about-name-block">
          <h2 className="about-name">Anna Gusovsky</h2>
          <div className="about-divider" />
          <p className="about-title">Counselor, MS, LPCC</p>
        </div>
        <div className="about-photo-frame">
          <img src="/images/anna-orchid-processed.jpg" alt="Anna Gusovsky, MS, LPCC — Licensed Professional Clinical Counselor at AG Health Counseling in Saint Louis Park, MN" />
        </div>
      </div>

      <div className="about-right">
        <p className="about-verified">✓ Verified by Psychology Today</p>
        <div className="about-divider-center" />

        <p className="about-bio">
          I'm a Licensed Professional Clinical Counselor (MS, LPCC) with over 25 years of
          experience in the helping professions. I work with adults navigating some of life's
          most challenging moments — bringing both clinical depth and genuine human warmth to
          every session. My multicultural background informs a practice that is inclusive,
          thoughtful, and deeply person-centered.
        </p>

        <div className="about-section">
          <h3 className="about-section-title">My Philosophy</h3>
          <p className="about-section-text">
            I believe the therapeutic relationship itself is a source of healing. I create an
            unhurried, non-judgmental space where you can speak freely, feel truly understood,
            and discover your own capacity for growth — drawing on a wide range of
            evidence-based and humanistic approaches, always adapting to what you need at your
            own pace.
          </p>
        </div>

        <div className="about-section">
          <h3 className="about-section-title">My Background</h3>
          <p className="about-section-text">
            With roots spanning multiple cultures and languages, I bring a uniquely empathetic
            lens to my work. I am fluent in English, Russian, and Ukrainian, and I welcome
            clients from all backgrounds and walks of life.
          </p>
        </div>

        <a href="#contact" className="about-btn" onClick={(e) => handleClick(e, 'contact')}>Book a Session</a>
      </div>
    </div>
  );
};

export default About;
